import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { SessionStorageService } from "../../../../shared/services/storage/session-storage.service";
import { SearchTableService } from "../../../../shared/services/table-column-mapping/search-table.service";
import { HttpClient } from "@angular/common/http";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { Router } from "@angular/router";
import { ArcGisGraveColumn } from "../arcgis-grave-column";
import { MapSearchService } from "../../../../shared/services/map-search/map-search.service";
import { PropertySearchOption } from "../../../properties/shared/models/property-heading.model";
import _ from "underscore";
import GeometryUtils from "../../../../shared/utils/geometry-utils";
import { BehaviorSubject } from "rxjs";
import { LocationsSearchColumnToArcGisColumnGraveLookup } from "../../../properties/shared/models/property-search-to-arcgis.model";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { SearchContainerHeight } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { GraveSearchOption } from "../models/grave/grave-search-option.enum";
import { CemeterySearchOption } from "../models/cemetery/cemetery-search-option.enum";
import { AppControllerService } from "../../../../app-controller.service";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
let GraveSearchService = class GraveSearchService extends MapSearchService {
    sessionStorageService;
    searchTableService;
    http;
    requestStatusService;
    appController;
    router;
    cemeteryUrl;
    graveUrl;
    cemeteryList = new BehaviorSubject([]);
    cemeteryListAsObservable = this.cemeteryList.asObservable();
    arcGisGraveOutColumnList = ArcGisGraveColumn;
    // @ts-ignore
    arcGisPropertyOutColumnList;
    gravesList = new BehaviorSubject(null);
    gravesListAsObservable = this.gravesList.asObservable();
    graveSearchTableColumnMap = new BehaviorSubject(null);
    graveSearchTableColumnMapObservable = this.graveSearchTableColumnMap.asObservable();
    searchOptionsMap;
    selectedSearchOptionLookup;
    cemeteryListAsObservableSubscription;
    constructor(sessionStorageService, searchTableService, http, requestStatusService, appController, router) {
        super(sessionStorageService, searchTableService);
        this.sessionStorageService = sessionStorageService;
        this.searchTableService = searchTableService;
        this.http = http;
        this.requestStatusService = requestStatusService;
        this.appController = appController;
        this.router = router;
        this.mapLocationAsObservable = this.mapLocation.asObservable();
    }
    getLayerUrl(searchType) {
        switch (searchType) {
            case CemeterySearchOption.Cemetery:
                return this.cemeteryUrl;
            case GraveSearchOption.Grave:
                return this.graveUrl;
            default:
                return this.cemeteryUrl;
        }
    }
    setURL(searchType, url) {
        switch (searchType) {
            case GraveSearchOption.Grave:
                this.graveUrl = url;
                break;
            case CemeterySearchOption.Cemetery:
                this.cemeteryUrl = url;
                break;
        }
    }
    clearURLList() {
        this.graveUrl = "";
        this.cemeteryUrl = "";
    }
    // @ts-ignore
    transformFeature(feature, searchOption) {
        switch (searchOption ? searchOption : this.searchType) {
            case CemeterySearchOption.Cemetery:
                return {
                    cemeteryObjectId: feature.attributes.ObjectID ? feature.attributes.ObjectID : (feature.attributes.objectid ? feature.attributes.objectid : null),
                    cemeteryName: feature.attributes.Name ? feature.attributes.Name : (feature.attributes.name ? feature.attributes.name : null),
                    cemeteryId: feature.attributes.CemeteryID ? feature.attributes.CemeteryID : (feature.attributes.cemeteryId ? feature.attributes.cemeteryId : null)
                };
            case GraveSearchOption.Grave:
                return {
                    id: feature.attributes.OBJECTID ? feature.attributes.OBJECTID : (feature.attributes.objectid ? feature.attributes.objectid : null),
                    plotNumber: feature.attributes.PlotNumber ? feature.attributes.PlotNumber : (feature.attributes.plotnumber ? feature.attributes.plotnumber : null),
                    graveId: feature.attributes.GraveID ? feature.attributes.GraveID : (feature.attributes.graveid ? feature.attributes.graveid : null),
                    capacity: feature.attributes.Capacity ? feature.attributes.Capacity : (feature.attributes.capacity ? feature.attributes.capacity : null),
                    markerType: feature.attributes.MarkerType ? feature.attributes.MarkerType : (feature.attributes.markertype ? feature.attributes.markertype : null),
                    graveStatus: feature.attributes.GraveStatus ? feature.attributes.GraveStatus : (feature.attributes.gravestatus ? feature.attributes.gravestatus : null),
                    condition: feature.attributes.Condition ? feature.attributes.Condition : (feature.attributes.condition ? feature.attributes.condition : null),
                    cemetery: feature.attributes.CemeteryID ? this.getCemeteryName(feature.attributes.CemeteryID) : (feature.attributes.cemeteryid ? this.getCemeteryName(feature.attributes.cemeteryid) : null),
                    geometry: feature.geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : null,
                };
        }
    }
    getCemeteryName(cemeteryId) {
        let name = "";
        this.cemeteryListAsObservableSubscription = this.cemeteryListAsObservable.subscribe((cemeteryList) => {
            cemeteryList.forEach((cemetery) => {
                if (cemetery.cemeteryObjectId === cemeteryId)
                    name = cemetery.cemeteryName;
            });
        });
        return name;
    }
    setGraveList(graves) {
        this.gravesList.next(graves);
    }
    setTableColumnMap(tableColumnMap) {
        this.graveSearchTableColumnMap.next(tableColumnMap);
    }
    setSelectedSearchOption(searchOption) {
        this.selectedSearchOptionLookup = this.getSearchOptionLookup(searchOption);
        // get columns related to search options type
        if (LocationsSearchColumnToArcGisColumnGraveLookup.get(this.selectedSearchOptionLookup)
            || LocationsSearchColumnToArcGisColumnGraveLookup.get(searchOption)) {
            this.searchType = GraveSearchOption.Grave;
        }
        else
            this.searchType = PropertySearchOption.Property;
    }
    setSearchOptionLookup(searchEnum) {
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(searchEnum)) {
            // @ts-ignore
            this.searchOptionsMap.set(key, value);
        }
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    clearGraveList() {
        this.gravesList.next([]);
    }
    getCemeteries() {
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        this.searchType = CemeterySearchOption.Cemetery;
        const url = this.getLayerUrl(CemeterySearchOption.Cemetery);
        // @ts-ignore
        this.searchForCemeteries(url).then((cemeteries) => {
            if (cemeteries && cemeteries.length > 0) {
                const sortedCemeteries = cemeteries.sort((a, b) => a?.cemeteryName?.localeCompare(b?.cemeteryName));
                this.cemeteryList.next(sortedCemeteries);
            }
        }).catch((error) => {
            this.appController.showConsoleMessage(error);
        })
            .finally(() => {
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        });
    }
    getCemeteriesWithAvailableGraves(url) {
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        // @ts-ignore
        this.searchForCemeteries(url).then((cemeteries) => {
            if (cemeteries && cemeteries.length > 0) {
                const sortedCemeteries = cemeteries.sort((a, b) => a?.cemeteryName?.localeCompare(b?.cemeteryName));
                this.cemeteryList.next(sortedCemeteries);
                return sortedCemeteries;
            }
        }).catch((error) => {
            this.appController.showConsoleMessage(error);
            return [];
        })
            .finally(() => {
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        });
        return [];
    }
    addGraveLocatorLink(gravesFound) {
        gravesFound.forEach(grave => {
            grave.link = this.setMapLink(grave, SearchContainerHeight.CemeteryLocationMap);
            // grave.link2 = this.setCreateApplicationLink(grave);
        });
        this.setGraveList(gravesFound);
    }
    getAttributeListForSearchType(searchOption) {
        switch (searchOption ? searchOption : this.searchType) {
            case CemeterySearchOption.Cemetery:
                return [];
            case GraveSearchOption.Grave:
                return [..._.values(this.arcGisGraveOutColumnList)];
            default:
                return [];
        }
    }
    setMapLink(grave, height) {
        return {
            text: SharedConstants.VIEW_ON_MAP_TEXT,
            address: "",
            clickAction: (link) => {
                this.changeMapLocation(String(grave.id), height);
            }
        };
    }
    static ctorParameters = () => [
        { type: SessionStorageService },
        { type: SearchTableService },
        { type: HttpClient },
        { type: RequestStatusService },
        { type: AppControllerService },
        { type: Router }
    ];
};
GraveSearchService = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], GraveSearchService);
export { GraveSearchService };
